import { useEffect, useRef } from "react";
import { getCookieConsent, loadAdSenseScript } from "@/components/CookieConsent";

interface AdSenseUnitProps {
  adSlot: string;
  adClient?: string;
  adFormat?: string;
  fullWidthResponsive?: boolean;
  className?: string;
}

const AdSenseUnit = ({
  adSlot,
  adClient = "ca-pub-5652998927875015",
  adFormat = "auto",
  fullWidthResponsive = true,
  className = "",
}: AdSenseUnitProps) => {
  const adRef = useRef<HTMLDivElement>(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    if (getCookieConsent() !== "accepted") return;
    // Load the AdSense script only when an ad unit actually mounts
    loadAdSenseScript();
    try {
      ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
      pushed.current = true;
    } catch (e) {
      console.error("AdSense push error:", e);
    }
  }, []);

  if (getCookieConsent() !== "accepted") return null;

  return (
    <div ref={adRef} className={className}>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={adClient}
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive ? "true" : "false"}
      />
    </div>
  );
};

export default AdSenseUnit;
